import { useState } from "react"
import { useParams } from "react-router"
import { Box, IconButton, Stack, Typography } from "@mui/material"
import { PageBreadcrumbContainer } from "lib/page-breadcrumb-container"
import { useSearchParam } from "lib/@hooks/use-search-param"
import LoadingScreen from "minimals-template/components/LoadingScreen"
import Iconify from "minimals-template/components/Iconify"
import { rateCard } from "routes/rate-cards/controller/rate-card"
import { RateCardEditor } from "./rate-card-editor"
import { GetStartedFab } from "routes/optimiser/get-started-fab"
import { useDemand } from "lib/authorization/use-demand"

const parentCrumbs = [
    { label: "Optimiser", to: "/app/optimiser" },
    { label: "Rate Cards", to: "/app/optimiser?optimiserTab=rate-cards" },
]

export function RateCardView() {
    const { id } = useParams()
    const card = rateCard.useResultsOnce({ id })
    const canManageOptimiser = useDemand("manageScenarios")
    const [menuAnchor, setMenuAnchor] = useState(null)
    const [getStarted] = useSearchParam("getStarted")

    if (card === undefined) return <LoadingScreen description="Loading Rate Card" />

    if (!card) {
        return (
            <PageBreadcrumbContainer title="Rate Card Not Found" parentCrumbs={parentCrumbs} sx={{ height: 1 }}>
                <Stack alignItems="center" justifyContent="center" sx={{ flex: 1, p: 3 }}>
                    <Typography variant="h6" color="text.secondary">
                        This rate card could not be found.
                    </Typography>
                </Stack>
            </PageBreadcrumbContainer>
        )
    }

    return (
        <PageBreadcrumbContainer
            title={card.name}
            heading={
                <Stack direction="row" spacing={1} sx={{ alignItems: "center", display: "inline-flex" }}>
                    <Box>{card.name}</Box>
                    <IconButton aria-label="More options" data-cy="rate-card-menu" size="small" onClick={openMenu}>
                        <Iconify icon="eva:more-vertical-fill" />
                    </IconButton>
                </Stack>
            }
            description={card.description}
            parentCrumbs={parentCrumbs}
            sx={{ height: 1 }}
        >
            <RateCardEditor
                card={card}
                id={id}
                menuAnchor={menuAnchor}
                setMenuAnchor={setMenuAnchor}
                readOnly={!canManageOptimiser}
            />
            <GetStartedFab defaultOpen={getStarted === "true"} />
        </PageBreadcrumbContainer>
    )

    function openMenu(e) {
        setMenuAnchor(e.currentTarget)
    }
}
